import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import firebase from "firebase";
import { AuthContext } from "../../Auth";
import "./style.scss";

const NickName = () => {
  const authContext = useContext(AuthContext);
  const [nickName, setNickName] = useState("");
  const [id, setId] = useState(0);
  const history = useHistory();
  const db = firebase.firestore();
  useEffect(() => {
    if (authContext.currentUser) {
      const min = 100;
      const max = 999;
      const rand = min + Math.random() * (max - min);
      setId(Math.floor(rand));
    } else {
      history.push("/");
    }
  }, []);

  const handleClickStart = () => {
    localStorage.nickName = nickName + "_" + id;
    db.collection("users")
      .doc(localStorage.email)
      .update({
        nickName: nickName + "_" + id,
      });
    history.push("/avatar");
  };

  const handleInputChange = (e) => {
    if (e.target.value[e.target.value.length - 1] !== " ") {
      let nickName = "";
      if (e.target.value) {
        nickName = e.target.value;
        setNickName(nickName);
      } else {
        setNickName("");
      }
    }
  };

  return (
    <>
      <div className="nickname">
        <img
          alt="logo"
          src={require("./../../assets/images/logo.svg")}
          className="nickname-logo"
        ></img>
        <div className="nickname-header">You are now connected!</div>
        <div className="nickname-body">
          <div className="nickname-body-guide">Please enter your nickname:</div>
          <input
            type="text"
            className="nickname-body-input"
            onChange={handleInputChange}
            value={nickName}
            pattern="[A-Za-z]{10}"
            maxLength={10}
          ></input>
          <div className="nickname-body-nickResult">Your nickname will be:</div>
          <div className="nickname-body-nickname">
            {nickName ? nickName + "_" + id : ""}
          </div>
          <button className="nickname-body-button" onClick={handleClickStart}>
            CONTINUE
          </button>
          <div className="nickname-body-question">Why nickname?</div>
          <div className="nickname-body-answer">
            We respect your privacy and we wont include any social network names
            you use, therefore select nickname of you choice.
          </div>
          <div className="nickname-body-comment">
            (_XXX) is added to prevent same nicknames.
          </div>
        </div>
      </div>
    </>
  );
};

export default NickName;
